import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Shippment } from '../../models/shippment/shippment-model';
import { SubscriberService } from '../../services/others/subscriber.service';
import { ShippmentService } from '../../services/shippment/shippment-setting';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-shipping-methods-list',
  templateUrl: './shipping-methods-list.component.html',
  styleUrls: ['./shipping-methods-list.component.scss']
})
/** shipping-methods-list component*/
export class ShippingMethodsListComponent {
  /** shipping-methods-list ctor */
  public subscriberList: Shippment[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** subscriber-list ctor */
  constructor(private readonly service: ShippmentService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("shippingmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.getShippingMethods();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  toggleShippingMethods(id) {
    this.service.ToggleShippingMethod(id);
    setTimeout(() => {
      this.getShippingMethods();
    }, 2000);
  }
  ChangeStatus(id) {
    this.service.ToggleShippingMethod(id).subscribe(
      data => {
        if (data) {
          this.toastr.success('Shipment Method Status has been Updated.', 'Success');
          setTimeout(() => {
            this.getShippingMethods();
          }, 2000);
        } else {
          this.toastr.error('Not Updated.', 'Error');
        }
      }
    );

  }

  getShippingMethods() {
    this.service.GetShippingMethods().subscribe(
      data => {
        this.subscriberList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.subscriberList, searchText);

    } else {
      this.filteredItems = this.subscriberList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shipping-components/shipping-methods-list/shipping-methods-list.component.ts